import { render } from "./ColonyRow.vue?vue&type=template&id=293dda03&ts=true"
import script from "./ColonyRow.vue?vue&type=script&lang=ts"
export * from "./ColonyRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__